import { Http, HttpAuth } from '../../config/Http';
import { changeLoading } from './loading.action';
import { changeNotify } from './notify.action';

export const actionTypes = {
    INDEX: 'BILHETES_INDEX',
    LIST: 'BILHETES_LIST',
    PAGOS: 'BILHETES_PAGOS'
};

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (id) => dispatch => {
    return Http.post('/bilhetes/'+id)
        .then(res => {
            if(typeof res !== 'undefined') {
                dispatch(changeLoading({ open: false }))
                dispatch(indexResponse(res.data))
                return res.data;
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            window.location.replace('/')
        })
}

export const listResponse = (payload, isLoadMore) => ({
    type: actionTypes.LIST,
    payload,
    isLoadMore
})

export const list = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/meus-bilhetes?'+ new URLSearchParams(query))
        .then(res => res && dispatch(listResponse(res.data, isLoadMore)))
}

/* TELEFONES */

export const cadastro = (email) => dispatch => {
    dispatch(changeLoading({ 
        open: true
    }))

    return HttpAuth.post('/email', {
        email: email
    })
    .then(res => {
        dispatch(changeLoading({ open: false }))
        if(res.data.users.length === 0) {
            dispatch(changeNotify({
                open: true,
                class: 'error',
                msg: 'Nenhum cadastro encontrado',
            }))
        }
        return res
    })
    .catch(erro => dispatch(changeLoading({ open: false })))
}

/* PAGOS */

export const pagosResponse = (payload, isLoadMore) => ({
    type: actionTypes.PAGOS,
    payload,
    isLoadMore
})

export const bilhetes = (id, query, isLoadMore) => dispatch => {
    return HttpAuth.get('/meus-bilhetes/'+id+'?'+ new URLSearchParams(query))
        .then(res => res && dispatch(pagosResponse(res.data, isLoadMore)))
}

/* DOWNLOAD */

export const download = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Preparando arquivo para Download...'
    }))

    return HttpAuth.post('/meus-bilhetes/'+id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            return res;
        })
        .catch(erro => dispatch(changeLoading({ open: false })))
}